export function unwrapResponse<T, K extends keyof T>(response: T, field: K): NonNullable<T[K]> {
  const value = response[field];
  if (value === null || value === undefined) {
    throw new Error(`missing ${String(field)} from response`);
  }
  return value;
}
